
import httpClient from "../http/http-client";
import { IEditFileUploadLine, IEditFileUploadLineDirectEmission, IEditFileUploadLineGood, IEditFileUploadLineGoodEmission, IEditFileUploadLineSpendBased, IEditFileUploadLineVehicle, IFileUploadLine, IFileUploadLineDirectEmission, IFileUploadLineGood, IFileUploadLineGoodEmission, IFileUploadLineSpendBased, IFileUploadLineVehicle, IPostFileUploadLine, IPostFileUploadLineDirectEmission, IPostFileUploadLineGood, IPostFileUploadLineGoodEmission, IPostFileUploadLineSpendBased, IReconciliationCandidate } from './file-upload-all-lines.model';

export default class FileUploadAllLineService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getUploadLinesWithPaginationByFile(fileType: string, fileUploadId: string, status: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IFileUploadLine[] | IFileUploadLineVehicle[] | IFileUploadLineGoodEmission[] | IFileUploadLineDirectEmission[] | IFileUploadLineSpendBased[] | IFileUploadLineGood[] }> {
    return this.http.get(`/file-upload-all-lines?fileType=${fileType}&fileUploadId=${fileUploadId}&status=${status}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`,)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getUploadLinesWithPaginationByReportPeriod(fileType: string, reportPeriodId: string, status: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IFileUploadLine[] | IFileUploadLineVehicle[] | IFileUploadLineGoodEmission[] | IFileUploadLineDirectEmission[] | IFileUploadLineSpendBased[] | IFileUploadLineGood[] }> {
    return this.http.get(`/file-upload-all-lines?fileType=${fileType}&reportPeriodId=${reportPeriodId}&status=${status}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`,)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOneUploadLine(fileType: string, lineId: string): Promise<IFileUploadLineSpendBased> {
    return this.http.get(`file-upload-all-lines/${lineId}?fileType=${fileType}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getUploadLineReconciliationCandidates(fileType: string, lineId: string): Promise<{ reconciliationCandidates: IReconciliationCandidate[] }> {
    return this.http.get(`file-upload-all-lines/${lineId}?fileType=${fileType}&reconciliationCandidates=true`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async editUploadLine(line: IEditFileUploadLine | IEditFileUploadLineDirectEmission | IEditFileUploadLineGoodEmission | IEditFileUploadLineVehicle | IEditFileUploadLineGood | IEditFileUploadLineSpendBased, fileUploadId: string, fileType: string, updateSupplier?: boolean, queryString?: string): Promise<any> {
    return this.http.patch(`/file-upload-all-lines/${fileUploadId}?fileType=${fileType}${updateSupplier ? '&updateSupplier=true' : ''}${queryString ? `&${queryString}` : ''}`, line)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async editManyFileUploadLines(ids: string[], line: Partial<IEditFileUploadLine | IEditFileUploadLineDirectEmission | IEditFileUploadLineGoodEmission | IEditFileUploadLineVehicle | IEditFileUploadLineGood | IEditFileUploadLineSpendBased>, fileType: string, create?: boolean): Promise<any> {
    const createQuery = typeof create === 'boolean' ? `&create=${create}` : ''
    return this.http.patch(`/file-upload-all-lines/edit/many?fileType=${fileType}${createQuery}`, { ids: ids, line: line })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async editAllFileUploadLines(fileUploadId: string, line: Partial<IEditFileUploadLine | IEditFileUploadLineDirectEmission | IEditFileUploadLineGoodEmission | IEditFileUploadLineVehicle | IEditFileUploadLineGood | IEditFileUploadLineSpendBased>, fileType: string, create?: boolean): Promise<any> {
    const createQuery = typeof create === 'boolean' ? `&create=${create}` : ''
    return this.http.patch(`/file-upload-all-lines/edit/all?fileType=${fileType}${createQuery}`, { fileUploadId: fileUploadId, line: line })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async commitSelectedFileUploadLines(fileUploadId: string, fileType: string, options: { ids?: string[], commitAll?: boolean, confirm?: boolean } = {}): Promise<{ needsConfirm: boolean, ready: number, requested: number, queued: number }> {
    return this.http.post(`/file-upload-all-lines/commit-selected?fileType=${fileType}`, {
      fileUploadId: fileUploadId,
      ids: options.ids,
      commitAll: options.commitAll === true,
      confirm: options.confirm === true,
    })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async createUploadLine(lines: IPostFileUploadLineDirectEmission[] | IPostFileUploadLine[] | IPostFileUploadLineGoodEmission[] | IPostFileUploadLineGood[] | IPostFileUploadLineSpendBased[], fileType: string, queryString?: string): Promise<any> {
    return this.http.post(`/file-upload-all-lines?fileType=${fileType}${queryString ? `&${queryString}` : ''}`, lines)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async deleteUploadLine(fileUploadId: string, fileType: string): Promise<any> {
    return this.http.delete(`/file-upload-all-lines/${fileUploadId}?fileType=${fileType}`,)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async deleteUploadLines(lines: IPostFileUploadLineDirectEmission[] | IPostFileUploadLine[] | IPostFileUploadLineGoodEmission[] | IPostFileUploadLineGood[] | IPostFileUploadLineSpendBased[], fileType: string): Promise<any> {
    return this.http.post(`/file-upload-all-lines/delete?fileType=${fileType}`, lines)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}